import React, { createRef, Component } from 'react';
import cx from 'classnames';
import FocusTrap from 'focus-trap-react';
import { AccessiblePortal, CloseType } from '@move-ui/portal';
import { ModalHeader } from './ModalHeader';
import { ModalFooter } from './ModalFooter';
import styles from './Modal.module.css';
import { SlideDirection } from './SlideDirection';
import { DialogRole } from './DialogRole';
export default class Modal extends Component {
    constructor(props) {
        super(props);
        this.modal = null;
        this.topRef = createRef();
        this.getTopElement = () => this.topRef.current;
        this.focusTop = () => {
            if (this.topRef && this.topRef.current) {
                this.topRef.current.focus();
            }
        };
        this.closeButtonClick = () => {
            const { onRequestClose } = this.props;
            onRequestClose({ closeType: CloseType.CloseButton });
        };
        this.onWrapperClick = this.onWrapperClick.bind(this);
    }
    componentDidMount() {
        const { isOpen } = this.props;
        if (isOpen) {
            this.open();
        }
    }
    componentDidUpdate(prevProps) {
        const { isOpen } = this.props;
        if (isOpen !== prevProps.isOpen) {
            this.toggle(!!isOpen);
        }
    }
    componentWillUnmount() {
        this.close();
    }
    onWrapperClick(e) {
        const { onRequestClose } = this.props;
        if (this.modal && !this.modal.contains(e.target)) {
            onRequestClose({ closeType: CloseType.ClickOutside });
        }
    }
    open() {
        const { onOpen } = this.props;
        document.body.classList.add(styles['is-modalOpen']);
        this.focusTop();
        onOpen === null || onOpen === void 0 ? void 0 : onOpen();
    }
    close() {
        document.body.classList.remove(styles['is-modalOpen']);
    }
    toggle(isOpen) {
        if (isOpen) {
            this.open();
        }
        else {
            this.close();
        }
    }
    render() {
        const { dialogRole = DialogRole.Modal, ariaLabelledBy, ariaDescribedBy, isOpen, classNames = {}, children, fullScreen, onRequestClose, onRequestBack, hideCloseButton, showBackButton, headerButtonLabel, renderHeader, renderFooter, slideDirection, pauseFocusTrap } = this.props;
        if (!isOpen) {
            return null;
        }
        return (React.createElement(AccessiblePortal, { isOpen: isOpen, closeOnEsc: true, onRequestClose: onRequestClose },
            React.createElement("div", { className: cx(styles.portalWrapper, classNames.portalWrapper) },
                React.createElement("div", { className: cx(styles.overlay, classNames.overlay) }),
                React.createElement(FocusTrap, { paused: !!pauseFocusTrap, className: styles.contentBoxWrapper, focusTrapOptions: {
                        fallbackFocus: this.getTopElement
                    } },
                    React.createElement("div", { tabIndex: -1, className: cx(styles.wrapper, classNames.wrapper), onMouseDown: this.onWrapperClick },
                        React.createElement("div", { ref: (node) => {
                                this.modal = node;
                            }, className: cx(styles.base, classNames.base, {
                                [styles.slideToTop]: slideDirection === SlideDirection.ToTop,
                                [styles.slideToLeft]: slideDirection === SlideDirection.ToLeft,
                                [styles.slideToRight]: slideDirection === SlideDirection.ToRight,
                                [styles.fullScreen]: fullScreen
                            }) },
                            React.createElement("div", { tabIndex: -1, role: dialogRole, "aria-modal": "true", "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy, className: cx(styles.contentBox, classNames.box) },
                                React.createElement(ModalHeader, { showCloseButton: !hideCloseButton, showBackButton: showBackButton, className: classNames.header, onButtonClick: showBackButton ? onRequestBack : this.closeButtonClick, buttonLabel: headerButtonLabel, slideDirection: slideDirection },
                                    React.createElement("div", { className: styles.headerContentWrapper, tabIndex: -1 }, renderHeader === null || renderHeader === void 0 ? void 0 : renderHeader())),
                                React.createElement("div", { className: cx(styles.contentWrapper, slideDirection && styles.slideInContentWrapper, classNames.contentWrapper), ref: this.topRef }, children),
                                renderFooter && (React.createElement(ModalFooter, { className: classNames.footer }, renderFooter())))))))));
    }
}
//# sourceMappingURL=Modal.js.map